import store from "store";

import {
  IStoreState,
  defaultStoreState,
} from "../stateUtils";

const storeKey = "pga-leader-board-store";

export const getStore = (): IStoreState => store.get(storeKey) || defaultStoreState;

export const setStore = (val: IStoreState): void => store.set(storeKey, val);

export const clearStore = (): void => store.remove(storeKey);
